module.exports = __webpack_public_path__ + "img/geocode-icon.f0c75119.svg";